
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2AddFriendDialogProperties } from "./Poker2AddFriendDialogProperties";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2AddFriendDialog extends Poker2Dialog {
    public static NAME: string = "Poker2AddFriendDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
    }

    public get isUnique(): boolean {
        return false;
    }

    protected applyProperties(): void {
        this.friendDialog.btn_yes.label = Poker2Model.languageData.getTextById("generic_btn_yes");
        this.friendDialog.btn_no.label = Poker2Model.languageData.getTextById("generic_btn_no");
        this.friendDialog.txt_title.text = Poker2Model.languageData.getTextById("generic_friends_add_title");
        this.friendDialog.txt_copy.text = Poker2Model.languageData.getTextById("generic_friends_add_copy", [this.friendProperties.playerName]);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        var paramObject: any;

        switch (event.target) {
            case this.friendDialog.btn_close:
            case this.friendDialog.btn_no:
                this.hide();
                paramObject = { status: 2, offerPID: this.friendProperties.playerId, receivePID: Poker2Model.userData.playerID };
                BasicModel.smartfoxClient.sendMessage("big", [JSON.stringify(paramObject)]);
                break;
            case this.friendDialog.btn_yes:
                this.hide();
                paramObject = { status: 1, offerPID: this.friendProperties.playerId, receivePID: Poker2Model.userData.playerID };
                BasicModel.smartfoxClient.sendMessage("big", [JSON.stringify(paramObject)]);
                break;
        }
    }

    protected get friendProperties(): Poker2AddFriendDialogProperties {
        return this.properties as Poker2AddFriendDialogProperties;
    }

    protected get friendDialog(): Library.PokerInterface.PokerStandardYesNo {
        return this.disp as Library.PokerInterface.PokerStandardYesNo;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set isUnique(value/*:Boolean*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Dialog.prototype, "isUnique").set.call(this, value);
    }
}
import { BIGCommand } from "../../controller/commands/buddy/BIGCommand";
